import React from 'react';
import _ResponsiveProductCarousel from 'src/components/Modules/ResponsiveProductCarousel';

import { compose } from 'redux';
import { ContentModuleGroupPreloadingContext } from 'src/constrains/DraggableModules/PreloadComponent/SubscriptionPreloading';
import { EPreviewSize } from 'src/types/common/SalesChannel';
import ContentGroupHOC from '../HOC';

const ResponsiveProductCarousel = (props) => {
  const {
    staticData,
    dynamicData,
    handleOnItemDelete,
    handleItemOnSort,
    handleOnStaticsChange,
    linkSet,
    specificError,
    droppableId,
    handleOnReselect,
    extraProps,
  } = props || {};

  const { breakpoint } = extraProps;
  const isConvertible = EPreviewSize.WIDE !== breakpoint;
  const { animations, hoverAnimations, buttons } = React.useContext(
    ContentModuleGroupPreloadingContext,
  );
  //console.log('specificError', specificError);
  //console.log('props', props);
  //console.log('handleOnReselect', handleOnReselect);
  //productNumberErr
  return (
    <_ResponsiveProductCarousel
      isConvertible={isConvertible}
      staticData={staticData}
      products={dynamicData}
      onItemDelete={handleOnItemDelete}
      onItemReselect={handleOnReselect}
      onItemSort={handleItemOnSort}
      onStaticChange={handleOnStaticsChange}
      linkSet={linkSet}
      specificError={specificError}
      droppableId={droppableId}
      animations={animations}
      hoverAnimations={hoverAnimations}
      buttons={buttons}
      // onItemReselect={handleOnCarouselItemReselect}
    />
  );
};
export default compose(ContentGroupHOC)(ResponsiveProductCarousel);
